import React, { useState } from "react";
import {
    Avatar,
    IconButton,
    Menu,
    MenuItem,
    ListItemIcon,
    Divider,
} from "@mui/material";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import LogoutIcon from "@mui/icons-material/Logout";

export type Props = {
    photoURL?: string | null;
    onTrips: () => void;
    onLogout: () => void;
    isDark: boolean;
};

export default function UserMenu({ photoURL, onTrips, onLogout, isDark }: Props) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);

    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => setAnchorEl(null);

    return (
        <>
            {/* Avatar Button */}
            <IconButton onClick={handleOpen} size="small">
                <Avatar
                    key={photoURL}
                    src={photoURL}
                    sx={{
                        width: 36,
                        height: 36,
                        border: "2px solid rgba(255,255,255,0.2)",
                    }}
                />
            </IconButton>

            {/* Dropdown */}
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                slotProps={{
                    paper: {
                        sx: {
                            mt: 1.5,
                            borderRadius: 3,
                            minWidth: 180,
                            backdropFilter: "blur(12px)",
                            background: isDark ? "rgba(30,30,30,0.85)" : "white",
                            border: "1px solid rgba(255,255,255,0.1)",
                        }
                    }
                }}
            >
                <MenuItem
                    onClick={() => {
                        handleClose();
                        onTrips();
                    }}
                >
                    <ListItemIcon>
                        <DirectionsCarIcon fontSize="small" />
                    </ListItemIcon>
                    Trips
                </MenuItem>

                <Divider />

                <MenuItem
                    onClick={() => {
                        handleClose();
                        onLogout();
                    }}
                >
                    <ListItemIcon>
                        <LogoutIcon fontSize="small" />
                    </ListItemIcon>
                    Logout
                </MenuItem>
            </Menu>
        </>
    );
}